import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from '@/router';
import { useAuthListener } from '@/hooks/useAuth';
import ToastContainer from '@/components/ui/Toast';
import CookieBanner from '@/components/ui/CookieBanner';
import '@/i18n/config';
import './index.css';

function AppContent() {
  useAuthListener();

  // Cacher le splash web dès que React est monté
  useEffect(() => {
    const hide = (window as any).__hideSplash;
    if (typeof hide === 'function') {
      setTimeout(hide, 300);
    }
  }, []);

  return (
    <>
      <RouterProvider router={router} />
      <ToastContainer />
      <CookieBanner />
    </>
  );
}

export default function App() {
  return <AppContent />;
}
